import { useMemo } from "react";
import ServiceClient from "../ServiceClient";
import ServiceTransaction from "../ServiceTransaction";
import { useServiceClient } from "../ServiceClientContext";

interface Forecast {
  date: string;
  temperatureC: number;
  temperatureF: number;
  summary: string;
}

interface WeatherOutput {
  forecasts: Forecast[];
}

class TestServiceClient {
  constructor(private serviceClient: ServiceClient) {}

  public async getTestWeather(): Promise<ServiceTransaction<WeatherOutput>> {
    return this.serviceClient.get("/test/weather");
  }
}

export type { Forecast, WeatherOutput };
export default TestServiceClient;

export function useTestServiceClient(): TestServiceClient {
  const serviceClient = useServiceClient();
  return useMemo(() => new TestServiceClient(serviceClient), [serviceClient]);
}
